import { Link, NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { List, X } from "@phosphor-icons/react";
import SearchPalette from "./SearchPalette";

const items = [
  { to: "/solutions", label: "Solutions Atlas" },
  { to: "/reels", label: "Reels" },
  { to: "/live", label: "Live" },
  { to: "/live-vision", label: "Live Vision" },
  { to: "/systems", label: "Systems in Motion" },
  { to: "/playbooks", label: "Playbooks" },
  { to: "/knowledge", label: "Knowledge" },
  { to: "/careers", label: "Careers" },
  { to: "/scoper", label: "AI Scoper" },
  { to: "/kosh", label: "KOSH" },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      data-testid="top-nav"
      className="sticky top-0 z-30 md:ml-20 border-b border-[#2A2A2A] bg-[#050505]/80 backdrop-blur"
    >
      <div className="flex items-center justify-between px-6 md:px-10 h-16">
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2">
            <img src="/wisewit-emblem.png" alt="Wisewit" className="w-9 h-9 object-contain" style={{ display: 'block' }} />
            <span className="font-display font-bold text-lg tracking-tight">
              wisewit<span className="text-[#FF4500]">.</span>ai
            </span>
          </Link>
          <div className="hidden md:flex items-center gap-2 ml-4 font-mono text-[10px] tracking-[0.25em] uppercase text-[#8E8E93]">
            <span className="w-1.5 h-1.5 bg-[#DFFF00] ww-pulse rounded-full" />
            <span>AI systems / industrial execution</span>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-6">
          {items.map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              data-testid={`topnav-${i.to.slice(1)}`}
              className={({ isActive }) =>
                `font-mono text-[11px] tracking-[0.18em] uppercase transition-colors ${
                  isActive ? "text-white" : "text-[#8E8E93] hover:text-white"
                }`
              }
            >
              {i.label}
            </NavLink>
          ))}
          <Link to="/contact" data-testid="topnav-cta" className="btn-primary">
            Start a project
          </Link>
          <SearchPalette />
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#2A2A2A] bg-[#050505] px-6 py-4 flex flex-col gap-3">
          {items.map((i) => (
            <Link
              key={i.to}
              to={i.to}
              onClick={() => setOpen(false)}
              data-testid={`mnav-${i.to.slice(1)}`}
              className={`font-mono text-xs tracking-[0.18em] uppercase ${
                loc.pathname === i.to ? "text-white" : "text-[#8E8E93]"
              }`}
            >
              {i.label}
            </Link>
          ))}
          <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary w-fit">
            Start a project
          </Link>
        </div>
      )}
    </header>
  );
}
